
  <ng-template #template1>
    <div class="border-0 rounded-0 pb-0">
      <div class="welcome-header">
      <h4 class="modal-title pull-left"></h4>
      <button type="button" class="close hide close-abs pull-right text-right" id="editclose" name="editclose" aria-label="Close" (click)="modalRef.hide();">
        <span aria-hidden="true"></span>
      </button>
      </div>
    </div>
    <div class="modal-body">
      <div class="p-2">
        <h3>Welcome to MOM</h3>
        <p class="text-secondary">Mom is secure Login for all your MOM applications. Use your DEWA credentials to access your applications seamlessly. All in one place and from any device!</p>
        <p class="text-secondary">
          Any Questions?
          drop an email at <a href="mailto:mom@dewa.gov.ae" class="pointer" target="_blank">mom@dewa.gov.ae</a>
        </p>
        <div class="text-center py-3">
          <button class="btn btn-success btn-sm" (click)="modalRef.hide();" routerLink="/dashboard">BACK TO MOM</button>
        </div>
      </div>      
    </div>   
  </ng-template>



<div class="container-fluid border-bottom py-2 bg-white header-sm-pos">
  <div class="row">
    <div class="col"><a routerLink="/dashboard"><img class="img-fluid" src="\assets\v2\img\dubai-gov-logo.png" style="max-height: 70px;width: auto;" alt="" /></a></div>
    <div class="col text-center"><img class="img-fluid"  src="\assets\v2\img\emirates-logo.png" alt="" /></div>
    <div class="col text-right"><img class="img-fluid" [src]="headerDynamicImage" alt="" width="250" /></div>
  </div>
</div>

<div class="nav-md sticky-top" [ngClass]="{'nav-md': shouldShow, 'nav-sm': !shouldShow }">
  <div class="header-container">
    <div class="main_container">
        <app-sidebar></app-sidebar>  
        <!--<app-sidebar end>-->     
          <div class="top_nav" id="main-menu">
              <header class="navbar navbar-expand flex-column flex-md-row navbar-light bg-white border-bottom">
                   <div class="navbar-nav-scroll">
                      <div class="nav toggle">                            
                          <a (click)="shouldShow=!shouldShow;toggleMenu()"><i class="las la-bars" [ngClass]="{'fa fa-navicon': shouldShow, 'la-bars': !shouldShow}"></i></a>
                        </div>
                  </div>                  
                  <div class="navbar-nav flex-row ml-md-auto d-md-flex ml-sm-auto d-sm-flex flex-row-reverse w-100">              
                      <div class="navbar navbar-expand-lg py-0 px-0 res-pad-right">                  
                          <!--app top header start-->                  
                          <div class="navbar-nav navbar-default header-rht-side">
                            <form class="form-inline border-right px-2">
                              <label class="sr-only" for="inlineFormInputGroupUsername2">Username</label>
                              <div class="input-group mb-2 mr-sm-2 mt-sm-2 search-section">
                                <div class="input-group-prepend">
                                  <div class="input-group-text search-pos-head p-0 border-0 ml-2"><i class="la la-search fa-2x"></i></div>
                                </div>
                                <a (click)="search()"> <input type="search" name="searchText" [(ngModel)]="searchText"  (keyup.enter)="search()" class="form-control w-350 rounded px-5 border-0" id="header-search" placeholder="Search..."></a>
                                
                              </div>
                            </form>
                            <ul class="navbar-nav mr-auto">

                              <!--<li class="nav-item" ngbDropdown>
                                <a class="nav-link" id="dropdownBasic1" (click)="openModalnewMeeting(template1);" title="Info" ngbDropdownToggle><i class="la la-info-circle fa-3x mx-1"></i></a>
                              </li>-->
                              <li class="nav-item" ngbDropdown>
                                <a class="nav-link" id="dropdownBasic1" (click)="markAsVisited()" title="Notification" ngbDropdownToggle><img src="\assets\v2\img\Notification@2x.png" class="whx-28 mt-2 mx-1 img-fluid" alt="Notification" /><span class="notification" *ngIf="alertCount>0">{{alertCount}}</span></a>
                                <!--<a class="nav-link" id="dropdownBasic1" (click)="markAsVisited()" title="Notification" ngbDropdownToggle><i class="fa fa-2x fa-bell mt-3 mx-2"></i><span class="notification" *ngIf="alertCount>0">{{alertCount}}</span></a>-->
                                <div ngbDropdownMenu aria-labelledby="dropdownBasic1" id="hideAddTask" class="dropdown-menu-right notification-box notify-drop dropdown-menu-right">

                                  <div class="notify-drop-title">
                                    <div class="row">
                                      <div class="col-sm-12 px-2">Notification <small class="text-danger">({{count}})</small></div>
                                    </div>
                                  </div>
                                  <!-- end notify title -->
                                  <!-- notify content -->
                                  <ul class="list-group drop-content m-0 p-0">
                                    <li class="bg-white py-4 text-center text-muted h-100 mb-3" *ngIf="alertList.length ===0 && alertList ">
                                      <!--<img src="{{noDataImage}}" class="img-fluid w-75" alt="No Data" />-->
                                      <h5>No Data Available</h5>
                                    </li>
                                    <li (click)="loadValues(alertObj)" class="border-bottom bg-lighty-blue" *ngFor="let alertObj of alertList; let alertIndex = index;">
                                      <p class="text-break px-2 py-2 pointer mb-0">
                                        <span class="d-block">{{alertObj.description}}</span>
                                        <small class="text-secondary position-top-minus-5 position-relative">{{alertObj.createdDate |timeAgo}} </small>
                                      </p>
                                    </li>
                                  </ul>
                                  <div class="notify-drop-footer text-center border-top pt-2">
                                    <a class="text-secoundary" (click)="CloseView()" [routerLink]="'/notificationlist'">View All</a>
                                  </div>
                                </div>
                              </li>
                              <!--<li class="nav-item" ngbDropdown>
                                <a class="nav-link" id="dropdownBasic1" (click)="markAsVisited()" title="Notification" ngbDropdownToggle><i class="fa fa-2x fa-bell mt-3 mx-2"></i><span class="notification" *ngIf="alertCount>0">{{alertCount}}</span></a>
                                <ul ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-right notification-box dropdown-menu-right">
                                  <li (click)="loadValues(alertObj)" class="border-bottom" *ngFor="let alertObj of alertList; let alertIndex = index;">
                                    <p class="text-break px-3 py-2 pointer mb-0">{{alertObj.description}}<br /> <b>{{alertObj.createdDate |timeAgo}} </b></p>
                                  </li>
                                  <li><a class="dropdown-item text-center" [routerLink]="'/notificationlist'"> View More </a></li>
                                </ul>
                              </li>-->
                            <li class="nav-item mt-0" ngbDropdown>                              
                              <!--<a class="nav-link" id="dropdownBasic1" title="User" ngbDropdownToggle><span><img class="rounded-circle header-profile-user" src="\assets\v2\img\user-default.png" id="imgProfile"  alt="user" /></span></a>-->
                              <a class="nav-link" id="dropdownBasic1" title="User" ngbDropdownToggle><span><img class="rounded-circle header-profile-user" [src]="profilePicture" id="imgProfile" alt="user" /></span></a>
                              <ul ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-right">
                                <li><a routerLink="/userprofile" ngbDropdownItem>Profile</a></li>
                                <li><a routerLink="/Videoguide" ngbDropdownItem>Help</a></li>
                                <li id="headerSettings" *ngIf="userRole==1"><a ngbDropdownItem routerLink="/meetingtype">Settings</a></li>
                                <li><a ngbDropdownItem (click)="logout_User()">Logout</a></li>
                              </ul>
                            </li>
                            </ul>                           
                          </div>                  
                          <!--app top header end-->
                        </div>  
                  </div>
                </header>
      
      </div>
    </div>
    </div>
  </div>





